<template>
	<div id="app">
		<Header v-if="!$route.meta.isAdmin" />
		<router-view></router-view>
		<Footer v-if="!$route.meta.isAdmin"/>
	</div>
</template>

<script>
	import Header from './components/header.vue'
	import Footer from './components/footer.vue'
	export default {
		name: 'App',
		components: {
			Header,
			Footer
		}
	}
</script>

<style lang="less">
	#app {
		min-width: 1080px;
	}

	.content {
		width: 1080px;
		margin: 20px auto;
		min-height: 400px;
	}

	.button-single {
		display: flex;
		justify-content: center;
		padding: 20px 0;

		span {
			display: block;
			width: 220px;
			height: 44px;
			background: #f55;
			border-radius: 2px;
			text-align: center;
			line-height: 44px;
			color: #fff;
			font-size: 16px;
			cursor: pointer;
		}
	}
	.pagination-wrap{
		display: flex;
		justify-content: flex-end;
		margin: 20px 0;
	}
</style>
